import { FC } from "react";
import { PDFViewer } from "@react-pdf/renderer";
import { useNavigate, useParams } from "react-router-dom";

import { MobileBaseLayout } from "../../layouts";
import { useGetPaymentRequestQuery } from "../../store/services/paymentRequests";
import { PDFPaymentRequest } from "../../components/pdf";
import { Button, Icon } from "../../components/common";

export const PaymentRequestDocumentPage: FC = () => {
  const { id } = useParams();
  const { data: paymentRequest } = useGetPaymentRequestQuery(id || "");

  const navigate = useNavigate();

  return (
    <MobileBaseLayout>
      <div className="flex pt-2">
        <Button
          className="p-0"
          icon
          onClick={() => navigate(-1)}
          variant={Button.variant.TERTIARY}
          size={Button.size.SMALL}
        >
          <Icon icon="Arrow-left" size={24} className="white" />
        </Button>
      </div>

      <div className="grow w-full h-full">
        <PDFViewer>
          {paymentRequest && <PDFPaymentRequest data={paymentRequest} />}
        </PDFViewer>
      </div>
    </MobileBaseLayout>
  );
};
